import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { stringify } from "query-string";
import { push } from "react-router-redux";
import {
  Pagination,
  SearchFilter,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { Button, Search } from "MODULES/shared/components";
import { API_BASE } from "APP_ROOT/constants";
import Table from "./Table";
import companiesPagination from "../pagination";

const ExportButton = ({ searchProps }) => {
  const params = Object.assign(searchProps.paginator.get("filters").toJS(), {
    vendor_status: "approved",
    sort: "name",
    reverse: false
  });

  return (
    <Button
      onClick={() =>
        window.open(
          `${API_BASE}/companies/export?${stringify(params)}`,
          "_blank"
        )}
    >
      Export
    </Button>
  );
};

ExportButton.propTypes = {
  searchProps: T.shape({
    paginator: T.instanceOf(Map)
  })
};

function ApprovedVendorSearch({ pushHistory }) {
  return (
    <Search search={companiesPagination} syncWithUrl>
      {searchProps => (
        <div>
          <div className="form-group form-group-searchbar has-feedback has-feedback-left">
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by typing a company name, code, or contact name..."
                submitOnSingleResult={r => pushHistory(`/companies/${r.id}`)}
              />
              <ExportButton searchProps={searchProps} />
            </div>
          </div>
          <TitleWithFilters {...searchProps} title="Approved Vendors" />
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

ApprovedVendorSearch.propTypes = {
  pushHistory: T.func.isRequired
};

export default connect(undefined, { pushHistory: push })(ApprovedVendorSearch);



// WEBPACK FOOTER //
// ./app/modules/ApprovedVendors/Search/Search.jsx